<template>
  <!-- FIXME rename to Missions.vue -->
  <main>
    <Row>
      <i-col :md="12" :xs="14">
        <p class="boldtext">{{ $t("Missions") }}</p>
      </i-col>
      <i-col :md="12" :xs="10" class="text-right" align="right">
        <button class="action-button" @click="showNewMissionModal">
          <Icon type="md-add" size="18" />
          {{ $t("Add mission") }}
        </button>
        <a class="export-link" @click="exportMissions()">
          <Icon type="md-cloud-download" size="20" :title="$t('Export missions')" />
        </a>
      </i-col>
    </Row>

    <!----------- [START] MAIN TABS ----------->
    <Tabs type="card" v-model="activeTab" @on-click="setMissionsDataSource">
      <!----------- [START] MAIN TAB ----------->

      <TabPane :label="tab.display_tab_name" :name="tab.value" :icon="tab.icon" v-for="tab in tabs" :key="tab.value">
        <section class="tabs-content-table">
          <!----------- [START] FILTERS  ----------->
          <Row class="d-flex px-5 flex-align-items-center flex-justify-content-center">
            <i-col class="mt-3">
              <!-- FILTER "SEARCH BY NAME" -->
              <i-col :md="9" :xs="24" class="mr-3">
                <Input
                  search
                  type="text"
                  class="max-width-100"
                  v-model="moduleComponents.missionsFilters.searchByName"
                  clearable
                  :placeholder="$t('Search by name')"
                />
              </i-col>
              <!-- FILTER "DESTINATION" -->
              <i-col :md="6" :xs="24" class="mr-3">
                <i-select
                  filterable
                  :placeholder="$t('Destination')"
                  class="max-width-100"
                  v-model="moduleComponents.missionsFilters.selectedCountry"
                  style="width: 175px"
                  clearable
                >
                  <i-option
                    v-for="country in moduleComponents.missionsFilters.countryList"
                    :key="country.value"
                    :value="country.value"
                    :label="country.display_name"
                  />
                </i-select>
              </i-col>
              <!-- FILTER "RISK" -->
              <i-col :md="6" :xs="24" class="mr-3">
                <Select
                  v-model="moduleComponents.missionsFilters.selectedCountryRisk"
                  class="max-width-100"
                  :placeholder="$t('Risk')"
                  style="width: 175px"
                  clearable
                >
                  <Option
                    v-for="item in moduleComponents.missionsFilters.countryRiskList"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.display_name }}
                  </Option>
                </Select>
              </i-col>
            </i-col>
          </Row>
          <!----------- [END] FILTERS  ----------->
          <transition appear name="slide-left-centered">
            <!----------- [START] TABLE ----------->
            <AppTable
              v-if="moduleComponents.missionsFilters.currentTab === tab.value"
              :columns="moduleComponents.missionsTable.headers"
              table-class="s2ec-table missions-table mt-5"
              :data-table="moduleComponents.missionsTable.data"
              :row-class-name="getMissionsTableRowClassName"
              ref="missionTable"
              @on-row-click="showMissionInfosModal"
              @on-sort-change="sortTableStyle"
              :no-data-text="$t('No data')"
              :loading="moduleComponents.missionsTable.isLoading"
            />
          </transition>

          <!----------- [END] TABLE ----------->
        </section>
      </TabPane>

      <!----------- [END] MAIN TAB ----------->
    </Tabs>
    <!----------- [END] MAIN TABS ----------->

    <!----------- [START] MODAL "TRAVEL INFOS" ----------->
    <EditMissionModal ref="editMissionModal" @missionCreated="missionsAltered" @missionUpdated="missionsAltered" />
    <!----------- [END] MODAL "TRAVEL INFOS" ----------->

    <!----------- [START] MODAL "TRAVEL INFOS" ----------->
    <MissionInfosModal ref="missionInfosModal" :mission="model.selectedMission" />
    <!----------- [END] MODAL "TRAVEL INFOS" ----------->
  </main>
</template>

<script>
/* IMPORTS
 * ------------------------------------------------------------------------- */
import EditMissionModal from "./modals/EditMissionModal";
import MissionInfosModal from "./modals/MissionInfosModal";
import { getMissionsQry, deleteMissionQry, exportMissionsQry } from "@/services/missionManagement.service";
import { getCountriesQry } from "@/services/common.service";
import { capitalizeFirstLetter } from "@/services/utilities";
import { getAuthSession } from "@/helpers/auth.helper";
import { getRiskQry, getGlobalRisks } from "@/services/countryInfo.service";
import DateFormat from "@/mixins/dateFormat";
import AppTable from "@/components/common/AppTable";
import moment from "moment";
export default {
  name: "MissionManagement",
  components: {
    EditMissionModal,
    MissionInfosModal,
    AppTable,
  },
  mixins: [DateFormat],
  props: {},
  data() {
    return {
      activeTab: "pending",
      model: {
        missions: {
          inProgress: [],
          realMissionExample: [
            // DUMMY EXAMPLE, IMMEDIATELY OVERRIDDEN
            {
              id: 9999,
              user: 374,
              user_value: {
                id: 374,
                is_active: true,
                email: "transient@test.com",
                first_name: "TestFirstName1",
                last_name: "TestLastName1",
                get_full_name: "TestFirstName1 TestLastName1",
                job_title: "",
                account_type: 1,
                avatar: null,
                cellphone: "+33766554433",
                landline: "+33144556677",
                registration_status: 1,
                registration_status_name: "Self Sign-up",
                account_type_value: "Traveler",
                on_alert: false,
                on_emergency: false,
                company: 9,
                company_name: "S2E Consulting",
              },
              mission_flight_bookings: [],
              destination_country: "FR",
              destination_country_name: "France",
              start_date: "2021-03-25T11:08:24.615356Z",
              end_date: "2021-03-30T11:08:24.615356Z",
              global_risk: 2,
              is_round_trip: false,
              created: "2021-03-15T11:08:30.846098Z",
              updated: "2021-03-15T11:08:30.846098Z",
            },
          ],
        },
        selectedMission: null,
      },
      tabs: [
        {
          value: "pending",
          display_tab_name: this.$t("Planification"),
          icon: "md-calendar",
        },
        {
          value: "started",
          display_tab_name: this.$t("Deplacements"),
          icon: "md-plane",
        },
        {
          value: "finished",
          display_tab_name: this.$t("Archives"),
          icon: "md-folder",
        },
      ],
      moduleComponents: {
        countriesList: [],
        missionsFilters: {
          currentTab: "pending",
          countryList: [],
          countryRiskList: [
            // Do not display risk level 0!
            {
              value: 1,
              display_name: this.$t("Risk") + " 1",
            },
            {
              value: 2,
              display_name: this.$t("Risk") + " 2",
            },
            {
              value: 3,
              display_name: this.$t("Risk") + " 3",
            },
            {
              value: 4,
              display_name: this.$t("Risk") + " 4",
            },
            {
              value: 5,
              display_name: this.$t("Risk") + " 5",
            },
          ],
          searchByName: "",
          selectedCountry: "",
          selectedCountryRisk: "",
        },
        missionsTable: {
          isLoading: false,
          data: [],
          headers: [],
        },
      },
    };
  },
  computed: {
    missionFiltersHack() {
      return [
        this.moduleComponents.missionsFilters.searchByName,
        this.moduleComponents.missionsFilters.selectedCountry,
        this.moduleComponents.missionsFilters.selectedCountryRisk,
      ];
    },
    lastNotification() {
      return this.notificationStore.lastNotification;
    },
  },
  watch: {
    missionFiltersHack() {
      this.refreshMissionsDisplay();
    },
    lastNotification(mission) {
      if (mission.hasOwnProperty("content_object")) {
        this.showModalMissionFromNotification(mission);
      }
    },
  },
  created() {
    this.lookupMissionsOptions();
    this.refreshMissionsDisplay();
  },
  mounted() {
    if (this.lastNotification.hasOwnProperty("content_object")) {
      this.showModalMissionFromNotification(this.lastNotification);
    }
  },
  methods: {
    showModalMissionFromNotification(mission) {
      let missionId = mission.content_object.id;
      if (mission.content_object.hasOwnProperty("start_date")) {
        this.activeTab = this.getMissionStatus(mission.content_object.start_date, mission.content_object.end_date);
        this.setMissionsDataSource(this.activeTab);
        let intervalId = setInterval(() => {
          if (!this.moduleComponents.missionsTable.isLoading && this.model.missions.inProgress.length > 0) {
            const missionSelected = this.model.missions.inProgress.find((m) => m.id === missionId);
            clearInterval(intervalId);
            this.model.selectedMission = missionSelected;
            this.$refs.missionInfosModal.show();
            this.notificationStore._resetLastNotification();
          }
        }, 1000);
      }
    },
    getMissionStatus(startDate, endDate) {
      let now = moment();
      let start = moment(startDate.substring(0, 10));
      let end = moment(endDate.substring(0, 10));

      if (now.isBefore(start)) {
        return "pending";
      } else if (now.isBetween(start, end)) {
        return "started";
      } else if (now.isAfter(end)) {
        return "finished";
      }
    },
    lookupMissionsOptions() {
      getCountriesQry().then((res) => {
        this.moduleComponents.missionsFilters.countryList = res.data; // FIXME replace with worldInfoStore.countryList
      });
    },
    resetMissionsFilters() {
      // Can't use this.resetDataName() since these are nested values...
      let initialMissionsFiltersData = this.$options.data.apply(this).moduleComponents.missionsFilters;
      let defaultMissionsFilters = {
        searchByName: initialMissionsFiltersData.searchByName,
        selectedCountry: initialMissionsFiltersData.selectedCountry,
        selectedCountryRisk: initialMissionsFiltersData.selectedCountryRisk,
      };
      Object.assign(this.moduleComponents.missionsFilters, defaultMissionsFilters);
    },
    _doRefreshMissionsDisplay() {
      this.moduleComponents.missionsTable.isLoading = true;
      this.moduleComponents.missionsTable.data = [];

      this.model.missions.inProgress = [];

      let filters = { page_size: 500 };
      filters["phase"] = this.moduleComponents.missionsFilters.currentTab || "pending";

      let missionsFilters = this.moduleComponents.missionsFilters;
      if (missionsFilters.selectedCountryRisk) filters["risk"] = missionsFilters.selectedCountryRisk;
      if (missionsFilters.selectedCountry) filters["destination_country"] = missionsFilters.selectedCountry;
      if (missionsFilters.searchByName) filters["user_search"] = missionsFilters.searchByName;

      getMissionsQry(filters)
        .then((res) => {
          // BEWARE - this result can arrive whereas tab has already been switched...
          this.model.missions.inProgress = [];
          this.model.missions.inProgress = res.data.results;
          this.setMissionsTableModuleComponentData();
          this.moduleComponents.missionsTable.headers = this.getMissionsTableModuleComponentHeaders();
        })
        .catch((exc) => {
          this.$Message.error({
            content: this.$t("Error retrieving missions"),
            duration: 5,
          });
        })
        .finally(() => {
          this.moduleComponents.missionsTable.isLoading = false;
        });
    },
    refreshMissionsDisplay(skipDebounce) {
      if (skipDebounce) this._doRefreshMissionsDisplay();
      else this.lodash.debounce(this._doRefreshMissionsDisplay, 500)();
    },
    updateMission(rawMissionData, rowIndex) {
      this.$refs.editMissionModal.showForMissionEdition(rawMissionData);
    },
    deleteMission(id, rowIndex) {
      let title = this.$t("Delete mission");
      let message = this.$t("Are you sure you want to delete this mission?");
      let successMessage = this.$t("Mission successfully deleted");
      let errorMessage = this.$t("Error performing your action");

      this.$AppModal.AppConfirm({
        method: "delete",
        extraTitle: title,
        message: message,
        loading: true,
        cancelText: this.$t("Cancel"),
        onConfirm: () => {
          deleteMissionQry(id)
            .then(() => {
              this.moduleComponents.missionsTable.data.splice(rowIndex, 1);
              this.$Message.success(successMessage);
            })
            .catch((e) => {
              this.$Message.error({ content: errorMessage, duration: 5 });
            })
            .finally(() => {
              this.$AppModal.remove();
            });
        },
      });
    },
    getMissionsTableModuleComponentHeaders() {
      // FIXME why lazy loading?
      let headers = [
        {
          title: this.$t("Name"),
          key: "userName",
          sortable: true,
          width: "250",
        },
        {
          title: this.$t("Destination"),
          key: "destination",
          sortable: true,
          width: "200",
        },
        {
          title: this.$t("Risk"),
          key: "riskLevel",
          sortable: true,
          render: (h, params) => {
            return h(
              "Tag",
              {
                props: {
                  color: this.getIViewTagComponentColorAttrValue(params.row.riskLevel),
                },
              },
              params.row.riskLevel != null ? params.row.riskLevel : "?"
            );
          },
        },
        {
          title: this.$t("Start date"),
          key: "startDate",
          sortable: true,
          align: "right",
        },
        {
          title: this.$t("End date"),
          key: "endDate",
          sortable: true,
        },
        {
          title: this.$t("Type"),
          key: "type",
          sortable: true,
        },
        {
          title: this.$t("PNR"),
          key: "pnr",
          sortable: true,
          render: (h, params) => {
            return [
              h("Checkbox", {
                props: {
                  value: params.row.pnr,
                  disabled: true,
                },
              }),
            ];
          },
        },
        {
          title: this.$t("Actions"),
          key: "actions",
          align: "right",
          render: (h, params) => {
            if (
              !(
                this.s2ec.user.is_superuser ||
                this.s2ec.user.is_admin ||
                this.s2ec.user.is_manager ||
                params.row.rawMissionData.user == getAuthSession().id
              )
            ) {
              return []; // No actions allowed on other users for unprivileged user
            }
            return [
              h("Button", {
                props: {
                  icon: "md-create",
                },
                attrs: {
                  title: this.$t("Edit"),
                },
                class: "table-button",
                on: {
                  click: (evt) => {
                    evt.stopPropagation(); // "click.stop" is not supported here
                    this.updateMission(params.row.rawMissionData, params.index);
                  },
                },
              }),
              h("Button", {
                props: {
                  icon: "md-trash",
                },
                attrs: {
                  title: this.$t("Delete"),
                },
                class: "table-button",
                on: {
                  click: (evt) => {
                    evt.stopPropagation(); // "click.stop" is not supported here
                    this.deleteMission(params.row.id, params.index);
                  },
                },
              }),
            ];
          },
        },
      ];
      return headers;
    },
    getIViewTagComponentColorAttrValue(riskLevel) {
      // FIXME duplicated block
      let color = "black";
      switch (riskLevel) {
        case 0:
          color = "#25c285";
          break;
        case 1:
          color = "#25c285";
          break;
        case 2:
          color = "#25c285";
          break;
        case 3:
          color = "#fbb000";
          break;
        case 4:
          color = "#ff6123";
          break;
        case 5:
          color = "#ff6123";
          break;
      }
      return color;
    },
    getMissionsTableRowClassName() {
      return "missions-table__row";
    },
    setMissionsDataSource(tabName) {
      this.resetMissionsFilters();
      this.moduleComponents.missionsFilters.currentTab = tabName;
      this.refreshMissionsDisplay(true);
    },
    setMissionsTableModuleComponentData() {
      let missionsDataSource = this.model.missions.inProgress;
      this.moduleComponents.missionsTable.data = [];

      missionsDataSource.forEach((missionData) => {
        this.moduleComponents.missionsTable.data.push({
          id: missionData.id,
          userName: missionData.user_value.full_name,
          destination: missionData.destination_country_name,
          riskLevel: missionData.global_risk,
          startDate: this.dateFormat(missionData.start_date),
          endDate: this.dateFormat(missionData.end_date),
          pnr: missionData.pnr_code ? true : false,
          type: missionData.mission_type_name,
          rawMissionData: missionData,
        });
      });
    },
    showMissionInfosModal(tableRow, tableRowIndex) {
      this.model.selectedMission = this.model.missions.inProgress[tableRowIndex];

      this.$refs.missionInfosModal.show();
    },
    sortTableStyle(tableRow) {
      //do not work ToDo
      tableRow.column.className = "bold";
      tableRow.className = "bold";
    },
    showNewMissionModal() {
      this.$refs.editMissionModal.show();
    },
    missionsAltered() {
      this.refreshMissionsDisplay();
    },
    triggerSelectCountry(country) {
      this.$router.push({ name: "country-info-detail", params: { country } });
    },
    show(index) {
      this.$Modal.info({
        title: "User Info",
        content: "test",
      });
    },
    remove(index) {
      this.data6.splice(index, 1);
    },
    exportMissions() {
      exportMissionsQry()
        .then((res) => {
          console.log("exportMissionsQry returned", res);
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "export.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          this.dataIsLoading = false;
          this.$Message.error({
            content: this.$t("Error retrieving data export"),
            duration: 5,
          });
        });
    },
  },
};
</script>

<style>
.ivu-checkbox-checked .ivu-checkbox-inner {
  background-color: var(--secondary-color) !important;
  border-color: var(--secondary-color) !important;
}

.ivu-checkbox-inner::after {
  border-color: var(--secondary-color) !important;
}
</style>
